import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Paragraph,
} from '@/components/atoms';
import { formatCurrency } from '@/lib/helpers/format-currency';
import { REFERRAL_CREDIT_NOTE } from '../constants';

interface ApplySubscriptionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  availableBalance: number;
  planPrice: number;
  renewalDate?: string;
  onConfirm: (amount: number) => void;
  isSubmitting?: boolean;
}

export const ApplySubscriptionDialog = ({
  open,
  onOpenChange,
  availableBalance,
  planPrice,
  renewalDate,
  onConfirm,
  isSubmitting = false,
}: ApplySubscriptionDialogProps) => {
  const appliedAmount = Math.min(availableBalance, planPrice);
  const remainderDue = Math.max(planPrice - availableBalance, 0);
  const coversFullPlan = availableBalance >= planPrice;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Apply to Subscription</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <Paragraph className="text-sm text-muted-foreground">
            Renewal {renewalDate ?? 'date on file'}
          </Paragraph>
          <Paragraph>
            Available earnings {formatCurrency(availableBalance)}
          </Paragraph>
          <Paragraph>
            {coversFullPlan
              ? `Apply ${formatCurrency(planPrice)} from your earnings?`
              : `Apply ${formatCurrency(appliedAmount)} and pay ${formatCurrency(remainderDue)} with your card?`}
          </Paragraph>
          <Paragraph className="text-sm text-muted-foreground">
            {REFERRAL_CREDIT_NOTE}
          </Paragraph>
        </div>

        <DialogFooter>
          <Button
            onClick={() => onConfirm(appliedAmount)}
            isLoading={isSubmitting}
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
